const NUMBER_TO_DIVIDE = 8000;
const NUMBER_TO_FINISH_SCALE = 8;
// Function to create an array with the values for the Title.
// eg: If the Highest value is 14.000, it will create an array with this values ['$0k','$2k','$4k','$6k','$8k','$10k','$12k','$14k']
const createScaleArray = (max) => {
  // This constant will give us the number of element the array will have. Based on the average we receive from the BE.
  const divitions = Math.ceil(max / NUMBER_TO_DIVIDE);
  const arr: string[] = [];

  for (let i = 0; i < NUMBER_TO_FINISH_SCALE; i++) {
    const number = i * divitions > max / 1000 ? max / 1000 : i * divitions;

    arr.push(`$${number}K`);
  }
  // here we return the array with the values and the amount of elements of the array to create the container.
  return arr;
};

export default createScaleArray;
